import { IAuswirkungenWirtschaftsplan } from "../IAuswirkungenWirtschaftsplan";
import { IBudgetantrag } from "../IBudgetantrag";
import { IFreigabekosten } from "../IFreigabekosten";
import { IProjektkostenPlan } from "../IProjektkostenPlan";
import { IRisikenChancen } from "../IRisikenchancen";

export interface IFreigabeViewModel {
    ursache?: string;
    bearbeiterVorheriger?: string;
    bearbeiterAktuell?: string;
    bearbeiterNaechster?: string;
    anmerkung?: string;
    budgetantrag: IBudgetantrag | null;
    freigabekosten: IFreigabekosten[] | null;
    budgetantragDifferenzen?: IProjektkostenPlan[];
    auswirkungenWirtschaftsplan?: IAuswirkungenWirtschaftsplan[];
    risikenChancen?: IRisikenChancen[];
    plausibilitaetText?: string;
    isPlausibel: boolean;
    fileNameAnhang?: string;
	mailSuccess: boolean;
    mailRespond?: string;
}

export class FreigabeViewModel implements IFreigabeViewModel {
    
    static default = {
        budgetantrag: null,
        freigabekosten: [],
        kostenherleitung: [],
        auswirkungenWirtschaftsplan: [],
        risikenChancen: [],
        ursache: "",
        bearbeiterVorheriger: "",
        bearbeiterAktuell: "",
        bearbeiterNaechster: "",
        anmerkung: "",
        plausibilitaetText: "",
        isPlausibel: false,
        mailSuccess: false,
        mailRespond: ""
    }

    constructor(
        public budgetantrag: IBudgetantrag,
        public freigabekosten: IFreigabekosten[],
        public budgetantragDifferenzen?: IProjektkostenPlan[],
        public auswirkungenWirtschaftsplan?: IAuswirkungenWirtschaftsplan[],
        public risikenChancen?: IRisikenChancen[],
        public ursache?: string,
        public bearbeiterVorheriger?: string,
        public bearbeiterAktuell?: string,
        public bearbeiterNaechster?: string,
        public anmerkung?: string,
        public plausibilitaetText? : string,
        public isPlausibel: boolean = false,
        public mailSuccess: boolean = false,
        public mailRespond?: string
    ) {}
}

